// 常量定义
export const SIDEBAR_WIDTH = {
  EXPANDED: 256,
  COLLAPSED: 60,
} as const;

export const ANIMATION_DURATION = {
  SHORT: 200,
  MEDIUM: 300,
  LONG: 500,
} as const;

export const Z_INDEX = {
  SIDEBAR: 1000,
  MENU: 1100,
  TOOLTIP: 1500,
} as const;

// 快捷提示数据
export const QUICK_PROMPTS = [
  {
    icon: "Lightbulb",
    title: "Give me a creative idea for a project",
    category: "Creative",
    iconBg: "#fef3c7",
    iconColor: "#d97706",
  },
  {
    icon: "Code",
    title: "Help me debug this code issue",
    category: "Programming",
    iconBg: "#dbeafe",
    iconColor: "#2563eb",
  },
  {
    icon: "Book",
    title: "Explain a complex concept in simple terms",
    category: "Learning",
    iconBg: "#f3e8ff",
    iconColor: "#7c3aed",
  },
  {
    icon: "Help",
    title: "I need help making a decision",
    category: "Advice",
    iconBg: "#ecfdf5",
    iconColor: "#059669",
  },
  {
    icon: "Write",
    title: "Write a short story or poem",
    category: "Writing",
    iconBg: "#fce7f3",
    iconColor: "#db2777",
  },
  {
    icon: "Chat",
    title: "Let's have a casual conversation",
    category: "Chat",
    iconBg: "#f0f9ff",
    iconColor: "#0284c7",
  },
] as const;

// 用户信息默认值
export const DEFAULT_USER = {
  name: "Username",
  role: "Regular User",
  avatar: "U",
} as const;

export const DATA_TYPE_OPTIONS: string[] = [
  "Account Details",
  "Subscription Details",
  "Success Plan Details",
  "Recent Activities",
  "Technical Support Cases",
  "Webex Meeting Usage",
  "Webex Calling Usage",
  "Webex Messaging Usage",
  "My Notes",
] as const;

export const JSON_DATA_DICT = {
  lifecycleAdoption: "lifecycleAdoption",
  wholesaleCustomerFlag: "Wholesale Customer",
  wholesalePartnerId: "Wholesale Partner ID",
  wholesalePartnerName: "Wholesale Partner Name",
  externalAlertColumn: "Alerts",
  accountId: "Account ID",
  accountName: "Account Name",
  bpp: "Beta Program Participation",
  cavId: "CAV ID",
  cavName: "CAV Name",
  cavBuId: "CAV Business Unit ID",
  cavBuName: "CAV Business Unit Name",
  partnerAccountName: "Partner Account Name",
  partnerGroup: "Partner Group",
  sites: "Site URLs",
  ciOrgId: "Control Hub Organization ID",
  meetingNPSScore: "Meetings NPS (last 30 days)",
  daysToRenewal: "Days to renewal",
  renewalDate: "Renewal Date",
  renewalQuarter: "Fiscal Renewal Quarter",
  country: "Country",
  state: "State/Province",
  channel: "Account Type",
  verticalIndustryName: "Industry Vertical",
  personalTags: "Personal Tags",
  savId: "SAV ID",
  savName: "SAV Name",
  subSalesCoverage: "Sub Sales Coverage",
  contractTheatre: "Contract Theatre",
  salesLevel1: "Sales Level 1",
  salesLevel2: "Sales Level 2",
  salesLevel3: "Sales Level 3",
  salesLevel4: "Sales Level 4",
  salesLevel5: "Sales Level 5",
  salesLevel6: "Sales Level 6",
  ciscoCsm: "Cisco Collab CSM",
  ccCsmName: "Contact Center Onboarding Solutions Manager",
  ccInlifeCsmName: "Contact Center CSM",
  partnerCsm: "Partner CSM",
  companyName: "Organization Name",
  escalationFlag: "Customer Escalation",
  desktopAppVersion: "Desktop App Version",
  expandPlanCreatedDate: "Collab CSM Success Plan",
  qvrFiscalQuarter: "Business Reviews",
  competitorDiscoveries: "Competitors",
  managementTags: "Shared Tags",
  dsmName: "DSM",
  ccseName: "CSE",
  arOffPCCount: "Auto Renew Off/Pending Cancel",
  healthScore: "OneView Health Score",
  alertGroup: "Health Rank",
  closestSubscriptionServiceStartDate: "Service Start Date",
  expandPlanRiskAssessment: "Customer Health Assessment (sourced from Collab CSM Success Plan)",
  callingEPDate: "Partner Success Plan",
  partnerTeamRisk: "Partner Success Risk Assessment",
  partnerTeamRiskNote: "Partner Success Risk Assessment Notes",
  ccseActivityLvl: "CSE Activity Level",
  ccseEPDate: "CSE Success Plan",
  evCsmEPDate: "Webex Events Success Plan",
  ccseRiskNote: "CSE Summary Notes and Asks",
  ccEPDate: "Contact Center Success Plan",
  cceRisk: "Contact Center Risk Assessment",
  cceRiskNote: "Contact Center Risk Assessment Notes",
  collabMapUploadedDate: "Collab Map",
  conciergeStatus: "Concierge",
  coverageStatus: "Account Engagement Model",
  aemExpReason: "AEM Exception Reason",
  aemExpDate: "AEM Exception Date",
  suiteAnchor: "Suite Anchor",
  callingEpsmName: "Calling ePSM",
  callingPsmName: "Calling PSM",
  ciOrgFoundationalStatus: "CH Foundational Config Status",
  ciOrgAdvanceStatus: "CH Advanced Config Status",
  productServices: "Products & Services",
  cxCseName: "OneX (CX) CSE",
  deviceAmount6M: "Total Device Bookings $$ (Last 6 Months)",
  deviceQty6M: "Total Device Bookings QTY (Last 6 Months)",
  deviceAmount12M: "Total Device Bookings $$ (Last 12 Months)",
  deviceQty12M: "Total Device Bookings QTY (Last 12 Months)",
  deviceAmount24M: "Total Device Bookings $$ (Last 24 Months)",
  deviceQty24M: "Total Device Bookings QTY (Last 24 Months)",
  deviceAmount3Y: "Total Device Bookings $$ (Last 3 Years)",
  deviceQty3Y: "Total Device Bookings QTY (Last 3 Years)",
  adoptionCloud6M: "Registered Device Cloud (Last 6 Months)",
  adoptionCloud12M: "Registered Device Cloud (Last 12 Months)",
  adoptionCloud24M: "Registered Device Cloud (Last 24 Months)",
  adoptionCloud3Y: "Registered Device Cloud (Last 3 Years)",
  adoptionEdge6M: "Registered Device Edge (Last 6 Months)",
  adoptionEdge12M: "Registered Device Edge (Last 12 Months)",
  adoptionEdge24M: "Registered Device Edge (Last 24 Months)",
  adoptionEdge3Y: "Registered Device Edge (Last 3 Years)",
  adoptionUnknown6M: "Registered Device Not Yet On Cloud (Last 6 Months)",
  adoptionUnknown12M: "Registered Device Not Yet On Cloud (Last 12 Months)",
  adoptionUnknown24M: "Registered Device Not Yet On Cloud (Last 24 Months)",
  adoptionUnknown3Y: "Registered Device Not Yet On Cloud (Last 3 Years)",
  videoDeviceCloudAmount6M: "Cloud Video Device Bookings $$ (Last 6 Months)",
  videoDeviceCloudAmount12M: "Cloud Video Device Bookings $$ (Last 12 Months)",
  videoDeviceCloudAmount24M: "Cloud Video Device Bookings $$ (Last 24 Months)",
  videoDeviceCloudAmount3Y: "Cloud Video Device Bookings $$ (Last 3 Years)",
  wemSuite: "Cloud Suite Bundle WEM",
  wemSuiteExpReason: "Cloud Suite Bundle WEM Exception Reason",
  wemSuiteExpBy: "Cloud Suite Bundle WEM Exception By",
  wemSuiteExpDate: "Cloud Suite Bundle WEM Exception Date",
  wemCallingOnPrem: "WEM Calling On-Prem",
  wemContactCenter: "WEM Contact Center",
  wemContactCenterExpReason: "WEM Contact Center Exception Reason",
  wemContactCenterExpBy: "WEM Contact Center Exception By",
  wemContactCenterExpDate: "WEM Contact Center Exception Date",
  wemVideoDevice: "WEM Video Device",
  wemVideoDeviceExpReason: "WEM Video Device Exception Reason",
  wemVideoDeviceExpBy: "WEM Video Device Exception By",
  wemVideoDeviceExpDate: "WEM Video Device Exception Date",
  resellerInfo: "Reseller Name & ID",
  resellerId: "Reseller Id",
  reseller: "Reseller",
  lifecycleStageByWorkload: "Lifecycle Stage by Workload",
  evCsmName: "Webex Events CSM",
  evCsmManagerName: "Webex Events CSM Manager",
  vidCsmName: "Webex Vidcast CSM",
  vidCsmManagerName: "Webex Vidcast CSM Manager",
  wellPlanIndFlag: "Get Well Plan",
  numOfTACTicketsOpen: "# TAC Tickets Open",
  numOfTACTicketsOpenLast90Days: "# TAC Tickets Last 90 Days",
  numOfBEMSTicketsOpen: "# BEMS Tickets Open",
  numOfBEMSTicketsOpenLast90Days: "# BEMS Tickets Last 90 Days",
  numOfEscalationTicketsOpen: "# Escalation Engineering Tickets Open",
  numOfEscalationTicketsOpenLast90Days: "# Escalation Engineering Tickets Last 90 Days",
  invoiceArrCustom: "Custom Invoice ARR/Bookings",
  invoiceArrMeetingMsgCloud: "Invoice ARR (Cloud Meetings + Messaging)",
  invoiceArrMeetingMsgOnPrem: "Invoice ARR (On-Prem Meetings + Messaging)",
  invoiceArrCallingCloud: "Invoice ARR (Cloud Calling)",
  invoiceArrCallingOnPrem: "Invoice ARR (On-Prem Calling)",
  invoiceArrContactCenterCloud: "Invoice ARR (Cloud Contact Center)",
  invoiceArrCloudWXCC: "Invoice ARR (Webex Contact Center)",
  invoiceArrCloudWXCCE: "Invoice ARR (Webex Contact Center Enterprise)",
  invoiceArrCloudWXCCAddon: "Invoice ARR (Webex Contact Center Add-Ons)",
  invoiceArrCloudWXCCDC: "Invoice ARR (Webex Contact Center Digital Channels)",
  invoiceArrContactCenterOnPrem: "Invoice ARR (On-Prem Contact Center)",
  invoiceArrDeviceCloud: "Invoice ARR (Cloud Devices)",
  invoiceArrDeviceOnPrem: "Invoice ARR (On-Prem Devices)",
  invoiceArrSuiteCustom: "Invoice ARR (Webex Suite)",
  invoiceArrSuiteMeetingCloud: "Invoice ARR Suite (Cloud Meetings + Messaging)",
  invoiceArrSuiteCallingCloud: "Invoice ARR Suite (Cloud Calling)",
  invoiceArrSuiteCallingOnPrem: "Invoice ARR Suite (On-Prem Calling)",
  invoiceArrTotal: "Invoice ARR (Collab + Non-Collab)",
  invoiceArrCollab: "Invoice ARR (Collab)",
  invoiceArrNonCollab: "Invoice ARR (Non-Collab)",
  invoiceArrOnPremAndCloud: "Invoice ARR (On-Prem + Cloud)",
  invoiceArrNoCPass: "Invoice ARR (On-Prem + Cloud - CPAAS)",
  invoiceArrOnPrem: "Invoice ARR (On-Prem)",
  invoiceArrCloud: "Invoice ARR (Cloud)",
  invoiceArrNonCollabSecurity: "Invoice ARR (Other - Security)",
  invoiceArrNonCollabService: "Invoice ARR (Other - Technical Support / Service)",
  invoiceArrNonCollabOther: "Invoice ARR (Other - Undefined)",
  invoiceArrCPassCloud: "Invoice ARR (Cloud - CPAAS GPL)",
  invoiceArrOrgTotal: "Organization Invoice ARR (Collab + Non-Collab)",
  aovCustom: "Custom AOV/Bookings",
  aovMeetingMsgCloud: "AOV (Cloud Meetings + Messaging)",
  aovMeetingMsgOnPrem: "AOV (On-Prem Meetings + Messaging)",
  aovCallingCloud: "AOV (Cloud Calling)",
  aovCallingOnPrem: "AOV (On-Prem Calling)",
  aovContactCenterCloud: "AOV (Cloud Contact Center)",
  aovCloudWXCC: "AOV (Webex Contact Center)",
  aovCloudWXCCE: "AOV (Webex Contact Center Enterprise)",
  aovCloudWXCCAddon: "AOV (Webex Contact Center Add-Ons)",
  aovCloudWXCCDC: "AOV (Webex Contact Center Digital Channels)",
  aovContactCenterOnPrem: "AOV (On-Prem Contact Center)",
  aovDeviceCloud: "AOV (Cloud Devices)",
  aovDeviceOnPrem: "AOV (On-Prem Devices)",
  aovSuiteCustom: "AOV (Webex Suite)",
  aovTotal: "AOV (Collab + Non-Collab)",
  aovCollab: "AOV (Collab)",
  aovNonCollab: "AOV (Non-Collab)",
  aovOnPremAndCloud: "AOV (On-Prem + Cloud)",
  aovNoCPass: "AOV (On-Prem + Cloud - CPAAS)",
  aovOnPrem: "AOV (On-Prem)",
  aovCloud: "AOV (Cloud)",
  aovCPassCloud: "AOV (Cloud - CPAAS GPL)",
  aovOrgTotal: "Organization AOV (Collab + Non-Collab)",
  aovNonCollabSecurity: "AOV (Other - Security)",
  aovNonCollabService: "AOV (Other - Technical Support / Service)",
  aovNonCollabOther: "AOV (Other - Undefined)",
  pjbMeetingsApp: "Participant Join Method - Meetings App",
  pjbMobileMeetingsApp: "Participant Join Method - Mobile Meetings App",
  pjbCloudVideoDevice: "Participant Join Method - Cloud Video Device",
  pjbOnPremVideoDevice: "Participant Join Method - On-Prem Video Device",
  pjbWebApp: "Participant Join Method - Web App",
  pjbWebexApp: "Participant Join Method - Webex App",
  pjbMobileWebexApp: "Participant Join Method - Mobile Webex App",
  pjbVDI: "Participant Join Method - VDI",
  pjbUnknown: "Participant Join Method - Unknown",
  pjbrAPJC: "Participant Join Method - APJC",
  pjbrEMEA: "Participant Join Method - EMEA",
  pjbrLatinAmerica: "Participant Join Method - Latin America",
  pjbrNorthAmerica: "Participant Join Method - North America",
};

import {
  EmojiObjects as LightBulbIcon,
  Search as MagnifyIcon,
  BarChart as ChartIcon,
  Code as CodeIcon,
  AutoAwesome as SparklesIcon,
  Description as DocumentIcon,
} from "@mui/icons-material";

export const ICON_OPTIONS: Array<{
  id: string;
  icon: React.ElementType;
  color: string;
  label: string;
}> = [
  {
    id: "lightbulb",
    icon: LightBulbIcon,
    color: "#F59E0B",
    label: "Light Bulb",
  },
  { id: "magnify", icon: MagnifyIcon, color: "#3B82F6", label: "Search" },
  { id: "chart", icon: ChartIcon, color: "#8B5CF6", label: "Chart" },
  { id: "code", icon: CodeIcon, color: "#10B981", label: "Code" },
  {
    id: "sparkles",
    icon: SparklesIcon,
    color: "#EC4899",
    label: "Sparkles",
  },
  {
    id: "document",
    icon: DocumentIcon,
    color: "#F97316",
    label: "Document",
  },
];
